import React from "react";
//#region redux
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { AutoCompleteInput } from "components/common";
import { FormControl, Grid } from "@mui/material";
import { useSearchService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SearchBar: React.FC<any> = () => {
  const searchService = useSearchService();
  const navigate = useNavigate();
  const location = useLocation();

  const [showBackdrop, setShowBackdrop] = React.useState<boolean>(false);
  const [reloadKey, setReloadKey] = React.useState<number>(0);

  const currentCompanyId = useSelector((store: AppState) => store.auth.selectedCompany?.id);

  const onItemSelect = React.useCallback((newValue: AutocompleteListItem | null) => {
    const itemUrl = newValue?.data && searchService.getUrlByType(newValue?.data.type, newValue?.data.entityId);
    if (itemUrl)
      navigate(UrlHelper.formatPath(itemUrl), {
        state: { background: location },
      });
  }, []);

  const onClose = () => {
    setShowBackdrop(false);
  };

  const onFocus = () => {
    setShowBackdrop(true);
  };

  const onSearch = React.useCallback(async (value: string) => searchService.get(value), [currentCompanyId]);

  const onGroupUrlClick = (group: any) => {
    const groupUrl = searchService.getGroupUrlByType(Number(group));

    if (groupUrl) {
      setReloadKey(reloadKey + 1);
      setShowBackdrop(false);
      navigate(UrlHelper.formatPath(groupUrl), {
        state: { background: location },
      });
    }
  };

  const groupRightContent = (group: WintSuperkollAPIModel.SearchEntityType) => {
    return (
      <Grid item className={cssExports.link} onClick={onGroupUrlClick.bind(null, group)}>
        {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ViewAll)} ${groupLabelFormatter(
          group
        ).toLowerCase()}`}
      </Grid>
    );
  };

  const groupLabelFormatter = (group: WintSuperkollAPIModel.SearchEntityType) => {
    return LocalizationHelperInstance.getFormattedMessage(`Search.SearchEntityType_${group}`);
  };

  return (
    <Grid key={reloadKey} container className={cssExports.search}>
      {showBackdrop ? <div className={cssExports.backdrop} onClick={onClose}></div> : <></>}
      <FormControl fullWidth className={showBackdrop ? cssExports.withBackDrop : ""}>
        <AutoCompleteInput
          key={`grouped-main-search`}
          name={`grouped-main-search`}
          placeholder={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Search)}...`}
          icon={IconDefinitionConstants.WSearch}
          onItemSelect={onItemSelect}
          items={onSearch}
          clearInputOnSelection
          classes={{
            popper: cssExports.searchPopper,
          }}
          onClose={onClose}
          onFocus={onFocus}
          hideDropdownIcon
          showLoading
          groupLabelFormatter={groupLabelFormatter}
          groupRightContent={groupRightContent}
        />
      </FormControl>
    </Grid>
  );
};

export default SearchBar;
